// ГРÁЙ Theater Website - Main JavaScript
document.addEventListener('DOMContentLoaded', function() {
    console.log('DOM loaded, initializing app...');
    initializeApp();
});

function initializeApp() {
    console.log('Initializing app...');
    setupNavigation();
    setupMobileMenu();
    setupInitialPage();
    setupInteractiveElements();
    console.log('App initialized successfully');
}

// Simple Navigation System
function setupNavigation() {
    console.log('Setting up navigation...');
    
    // Handle all navigation clicks with event delegation
    document.addEventListener('click', function(e) {
        console.log('Click detected:', e.target);
        const link = e.target.closest('[data-page]');
        const navCard = e.target.closest('[data-navigate]');
        
        if (link) {
            console.log('Navigation link clicked:', link.getAttribute('data-page'));
            e.preventDefault();
            const targetPage = link.getAttribute('data-page');
            showPage(targetPage);
            updateActiveNav(targetPage);
            closeMobileMenu();
        } else if (navCard) {
            console.log('Navigation card clicked:', navCard.getAttribute('data-navigate'));
            e.preventDefault();
            const targetPage = navCard.getAttribute('data-navigate');
            // Check if it's a photo subsection
            if (targetPage === 'backstage-photos' || targetPage === 'play-photos') {
                showPhotoSection(targetPage);
            } else {
                showPage(targetPage);
                updateActiveNav(targetPage);
            }
        }
    });
    
    // Handle browser navigation
    window.addEventListener('hashchange', function() {
        console.log('Hash changed:', window.location.hash);
        const pageId = getPageFromHash();
        showPage(pageId);
        updateActiveNav(pageId);
    });
    
    console.log('Navigation setup complete');
}

function showPage(pageId) {
    console.log('Showing page:', pageId);
    
    // Find current active page
    const currentPage = document.querySelector('.page.active');
    const targetPage = document.getElementById(pageId);
    
    if (!targetPage) {
        console.error('Target page not found:', pageId);
        return;
    }
    
    if (currentPage === targetPage) {
        console.log('Already on target page');
        return;
    }
    
    // Smooth transition with exit animation
    if (currentPage) {
        console.log('Animating out current page:', currentPage.id);
        currentPage.classList.add('exit');
        
        setTimeout(() => {
            // Hide all pages
            const allPages = document.querySelectorAll('.page');
            allPages.forEach(page => {
                page.classList.remove('active', 'exit');
                page.style.display = 'none';
            });
            
            // Show and animate in target page
            console.log('Target page found:', targetPage.id);
            targetPage.style.display = 'block';
            
            // Small delay to ensure display change is processed
            setTimeout(() => {
                targetPage.classList.add('active');
                
                // Animate page elements
                animatePageElements(targetPage);
                
                console.log('Page shown successfully:', pageId);
            }, 50);
            
        }, 400); // Match exit animation duration
    } else {
        // No current page, show target immediately
        const allPages = document.querySelectorAll('.page');
        allPages.forEach(page => {
            page.classList.remove('active');
            page.style.display = 'none';
        });
        
        targetPage.style.display = 'block';
        setTimeout(() => {
            targetPage.classList.add('active');
            animatePageElements(targetPage);
        }, 50);
    }
    
    // Update URL hash
    if (pageId !== 'home') {
        window.location.hash = pageId;
    } else {
        history.replaceState('', document.title, window.location.pathname);
    }
    
    // Scroll to top
    window.scrollTo(0, 0);
}

// Add page element animation function
function animatePageElements(page) {
    const animatableElements = page.querySelectorAll(
        '.feature-card, .nav-card, .show-card, .actor-card, .contact-section, .photo-item, .video-item, .show-item, .actor-item'
    );
    
    animatableElements.forEach((element, index) => {
        // Reset animation
        element.style.animation = 'none';
        element.offsetHeight; // Trigger reflow
        
        // Re-apply animation with staggered delay
        const delay = index * 0.1;
        element.style.animationDelay = `${delay}s`;
        
        if (element.classList.contains('feature-card')) {
            element.style.animation = 'floatIn 0.8s cubic-bezier(0.4, 0, 0.2, 1) forwards';
        } else if (element.classList.contains('actor-card') || element.classList.contains('video-item')) {
            element.style.animation = 'slideInUp 0.8s cubic-bezier(0.4, 0, 0.2, 1) forwards';
        } else if (element.classList.contains('photo-item')) {
            element.style.animation = 'scaleIn 0.8s cubic-bezier(0.4, 0, 0.2, 1) forwards';
        } else if (element.classList.contains('contact-section')) {
            element.style.animation = 'slideInLeft 0.8s cubic-bezier(0.4, 0, 0.2, 1) forwards';
        } else {
            element.style.animation = 'fadeInUp 0.8s cubic-bezier(0.4, 0, 0.2, 1) forwards';
        }
    });
}

function updateActiveNav(pageId) {
    // Remove active from all nav links
    document.querySelectorAll('.nav-link').forEach(link => {
        link.classList.remove('active');
    });
    
    // Add active to current nav link
    const activeLink = document.querySelector(`[data-page="${pageId}"]`);
    if (activeLink) {
        activeLink.classList.add('active');
    }
}

function getPageFromHash() {
    const hash = window.location.hash.substring(1);
    return hash || 'home';
}

function setupInitialPage() {
    const initialPage = getPageFromHash();
    showPage(initialPage);
    updateActiveNav(initialPage);
}

// Mobile Menu
function setupMobileMenu() {
    const navToggle = document.querySelector('.nav-toggle');
    const navMenu = document.querySelector('.nav-menu');
    
    if (navToggle) {
        navToggle.addEventListener('click', function() {
            navToggle.classList.toggle('active');
            navMenu.classList.toggle('active');
        });
    }
}

function closeMobileMenu() {
    const navToggle = document.querySelector('.nav-toggle');
    const navMenu = document.querySelector('.nav-menu');
    
    if (navToggle && navMenu) {
        navToggle.classList.remove('active');
        navMenu.classList.remove('active');
    }
}

// Interactive Elements
function setupInteractiveElements() {
    // CTA button
    const ctaButton = document.querySelector('.cta-button');
    if (ctaButton) {
        ctaButton.addEventListener('click', function() {
            showPage('story');
            updateActiveNav('story');
        });
    }
    
    // Play folder click handlers
    const playFolders = document.querySelectorAll('.play-folder');
    playFolders.forEach(folder => {
        folder.addEventListener('click', function() {
            const playId = this.getAttribute('data-play');
            showPlayPhotos(playId);
        });
    });
    
    // Add click ripple effect for buttons
    const buttons = document.querySelectorAll('button, .cta-button, .ticket-btn');
    buttons.forEach(button => {
        button.addEventListener('click', function(e) {
            const ripple = document.createElement('span');
            const rect = this.getBoundingClientRect();
            const size = Math.max(rect.width, rect.height);
            const x = e.clientX - rect.left - size / 2;
            const y = e.clientY - rect.top - size / 2;
            
            ripple.style.cssText = `
                position: absolute;
                border-radius: 50%;
                background: rgba(255, 255, 255, 0.3);
                transform: scale(0);
                animation: ripple-animation 0.6s linear;
                pointer-events: none;
                width: ${size}px;
                height: ${size}px;
                left: ${x}px;
                top: ${y}px;
            `;
            
            this.style.position = 'relative';
            this.style.overflow = 'hidden';
            this.appendChild(ripple);
            
            setTimeout(() => {
                ripple.remove();
            }, 600);
        });
    });
    
    // Add ripple animation styles if not exists
    if (!document.getElementById('ripple-styles')) {
        const style = document.createElement('style');
        style.id = 'ripple-styles';
        style.textContent = `
            @keyframes ripple-animation {
                to {
                    transform: scale(2);
                    opacity: 0;
                }
            }
        `;
        document.head.appendChild(style);
    }
}

function showPlayPhotos(playId) {
    // Hide all play photo sections
    const photoSections = document.querySelectorAll('.play-photos-section');
    photoSections.forEach(section => {
        section.classList.remove('active');
    });
    
    // Show the selected play photo section
    const targetSection = document.getElementById(`${playId}-photos`);
    if (targetSection) {
        targetSection.classList.add('active');
        
        // Scroll to the section
        setTimeout(() => {
            targetSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
        
        // Load ALL photos immediately if the function exists
        if (typeof loadAllPlayPhotos === 'function') {
            loadAllPlayPhotos(playId);
        }
    }
}

function showPhotoSection(sectionId) {
    // Hide all photo subsections
    const photoSubsections = document.querySelectorAll('.photo-subsection');
    photoSubsections.forEach(section => {
        section.classList.remove('active');
    });
    
    // Show the selected photo subsection
    const targetSection = document.getElementById(sectionId);
    if (targetSection) {
        targetSection.classList.add('active');
        
        // Scroll to the section
        setTimeout(() => {
            targetSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
    }
}

// Responsive handling
window.addEventListener('resize', function() {
    if (window.innerWidth > 768) {
        closeMobileMenu();
    }
});

// Lightbox functionality
let currentLightboxIndex = 0;
let currentLightboxPhotos = [];

function initLightbox() {
    // Add click handlers to all photo items
    document.addEventListener('click', function(e) {
        const photoItem = e.target.closest('.photo-item');
        if (photoItem) {
            e.preventDefault();
            const img = photoItem.querySelector('img');
            if (img) {
                openLightbox(img);
            }
        }
    });
    
    // Close lightbox handlers
    const lightbox = document.getElementById('photo-lightbox');
    const closeBtn = document.querySelector('.lightbox-close');
    const prevBtn = document.querySelector('.lightbox-prev');
    const nextBtn = document.querySelector('.lightbox-next');
    
    if (closeBtn) {
        closeBtn.addEventListener('click', closeLightbox);
    }
    
    if (prevBtn) {
        prevBtn.addEventListener('click', showPrevPhoto);
    }
    
    if (nextBtn) {
        nextBtn.addEventListener('click', showNextPhoto);
    }
    
    // Close when clicking outside image
    if (lightbox) {
        lightbox.addEventListener('click', function(e) {
            if (e.target === lightbox) {
                closeLightbox();
            }
        });
    }
    
    // Keyboard navigation
    document.addEventListener('keydown', function(e) {
        if (lightbox && lightbox.style.display === 'block') {
            switch(e.key) {
                case 'Escape':
                    closeLightbox();
                    break;
                case 'ArrowLeft':
                    showPrevPhoto();
                    break;
                case 'ArrowRight':
                    showNextPhoto();
                    break;
            }
        }
    });
}

function openLightbox(imgElement) {
    const lightbox = document.getElementById('photo-lightbox');
    const lightboxImg = document.getElementById('lightbox-image');
    const caption = document.querySelector('.lightbox-caption');
    
    if (!lightbox || !lightboxImg) return;
    
    // Find all photos in the same gallery
    const galleryContainer = imgElement.closest('.gallery-grid');
    if (galleryContainer) {
        const allPhotos = galleryContainer.querySelectorAll('.photo-item img');
        currentLightboxPhotos = Array.from(allPhotos);
        currentLightboxIndex = currentLightboxPhotos.indexOf(imgElement);
    } else {
        // Single photo
        currentLightboxPhotos = [imgElement];
        currentLightboxIndex = 0;
    }
    
    // Set image source and caption
    lightboxImg.src = imgElement.src;
    lightboxImg.alt = imgElement.alt;
    
    if (caption) {
        caption.textContent = imgElement.alt || '';
    }
    
    // Show lightbox
    lightbox.style.display = 'block';
    document.body.style.overflow = 'hidden';
    
    // Update navigation buttons visibility
    updateNavigationButtons();
}

function closeLightbox() {
    const lightbox = document.getElementById('photo-lightbox');
    if (lightbox) {
        lightbox.style.display = 'none';
        document.body.style.overflow = '';
    }
}

function showPrevPhoto() {
    if (currentLightboxPhotos.length <= 1) return;
    
    currentLightboxIndex = (currentLightboxIndex - 1 + currentLightboxPhotos.length) % currentLightboxPhotos.length;
    updateLightboxImage();
}

function showNextPhoto() {
    if (currentLightboxPhotos.length <= 1) return;
    
    currentLightboxIndex = (currentLightboxIndex + 1) % currentLightboxPhotos.length;
    updateLightboxImage();
}

function updateLightboxImage() {
    const lightboxImg = document.getElementById('lightbox-image');
    const caption = document.querySelector('.lightbox-caption');
    
    if (lightboxImg && currentLightboxPhotos[currentLightboxIndex]) {
        const currentImg = currentLightboxPhotos[currentLightboxIndex];
        lightboxImg.src = currentImg.src;
        lightboxImg.alt = currentImg.alt;
        
        if (caption) {
            caption.textContent = currentImg.alt || '';
        }
        
        updateNavigationButtons();
    }
}

function updateNavigationButtons() {
    const prevBtn = document.querySelector('.lightbox-prev');
    const nextBtn = document.querySelector('.lightbox-next');
    
    if (prevBtn && nextBtn) {
        const hasMultiplePhotos = currentLightboxPhotos.length > 1;
        prevBtn.style.display = hasMultiplePhotos ? 'block' : 'none';
        nextBtn.style.display = hasMultiplePhotos ? 'block' : 'none';
    }
}

// Initialize lightbox when DOM is loaded
initLightbox();

// Actor and Director Photo Loading Functions
function loadActorPhotos() {
    console.log('Loading actor photos...');
    
    // Load director photo - Clear container first to prevent duplicates
    const directorContainer = document.getElementById('director-container');
    if (directorContainer) {
        // Clear existing content to prevent duplicates
        directorContainer.innerHTML = '';
        
        const directorCard = document.createElement('div');
        directorCard.className = 'director-card';
        
        const directorImg = document.createElement('img');
        directorImg.src = './images/director/Ігор Вовк.jpg';
        directorImg.alt = 'Ігор Вовк';
        directorImg.className = 'director-photo';
        
        // Add click handler to show bio
        directorImg.addEventListener('click', function() {
            showBioModal('./images/director/Ігор Вовк.jpg', 'Ігор Вовк', 'Режисер', './images/director/bio.txt');
        });
        
        directorImg.onerror = function() {
            console.warn('Failed to load director photo');
            this.src = './images/main.png';
            this.alt = 'Фото відсутнє';
        };
        
        const directorName = document.createElement('h3');
        directorName.className = 'director-name';
        directorName.textContent = 'Ігор Вовк';
        
        // Add click handler to name as well
        directorName.addEventListener('click', function() {
            showBioModal('./images/director/Ігор Вовк.jpg', 'Ігор Вовк', 'Режисер', './images/director/bio.txt');
        });
        
        const directorTitle = document.createElement('p');
        directorTitle.className = 'director-title';
        directorTitle.textContent = 'Режисер';
        
        directorCard.appendChild(directorImg);
        directorCard.appendChild(directorName);
        directorCard.appendChild(directorTitle);
        
        directorContainer.appendChild(directorCard);
    }
    
    // Load actors photos
    const actorsContainer = document.getElementById('actors-container');
    if (actorsContainer) {
        // Define actor data with specific image filenames
        const actors = [
            { name: "Ганна Чітарі", folder: "1. Ганна Чітарі", image: "Web_Graj2025_192.jpg" },
            { name: "Дар'я Ра", folder: "2. Daria Ra", image: "Web_Graj2025_475.jpg" },
            { name: "Андрій Гудзоватий", folder: "4. Андрій Гудзоватий", image: "Web_Graj2025_145.jpg" },
            { name: "Олена Чеберда", folder: "5. Олена Чеберда", image: "Web_Graj2025_487.jpg" },
            { name: "Аліна Темірова", folder: "6. Аліна Темірова", image: "Web_Graj2025_107.jpg" },
            { name: "Андрій Губін", folder: "7. Андрій Губін", image: "Web_Graj2025_369.jpg" },
            { name: "Надія Лебедєва", folder: "8. Надія Лебедєва", image: "Web_Graj2025_401.jpg" },
            { name: "Анна Кобаль", folder: "9. Анна Кобаль", image: "Web_Graj2025_302.jpg" },
            { name: "Юлія Похиленко", folder: "10. Юлія Похиленко", image: "Web_Graj2025_047.jpg" },
            { name: "Анастасія Вантух", folder: "11. Анастасія Вантух", image: "Web_Graj2025_578.jpg" },
            { name: "Олексій Леонт'єв", folder: "12. Oleksii Leontiev", image: "Web_Graj2025_448.jpg" },
            { name: "Станіслав Антипов", folder: "13. Stanislav Antipov", image: "Web_Graj2025_171.jpg" },
            { name: "Вікторія Попкова", folder: "14. Вікторія Попкова", image: "Web_Graj2025_140.jpg" },
            { name: "Олена Місуркіна", folder: "15. Olena Misurkina", image: "Web_Graj2025_322.jpg" },
            { name: "Софія Рибакова", folder: "16. Софія Рибакова", image: "Web_Graj2025_252.jpg" }
        ];
        
        // Clear container
        actorsContainer.innerHTML = '';
        
        // Add each actor
        actors.forEach(actor => {
            const actorCard = document.createElement('div');
            actorCard.className = 'actor-card';
            
            // Create image element
            const img = document.createElement('img');
            const primarySrc = `./images/actors/${actor.folder}/${actor.image}`;
            img.src = primarySrc;
            img.alt = actor.name;
            img.className = 'actor-photo';
            
            // Add click handler to show bio
            img.addEventListener('click', async function() {
                // Try both possible bio file names
                const bioPath = await checkBioFileExists(`./images/actors/${actor.folder}/Bio.txt`, `./images/actors/${actor.folder}/bio.txt`);
                showBioModal(primarySrc, actor.name, 'Актор', bioPath);
            });
            
            // Add error handling
            img.onerror = function() {
                console.warn(`Failed to load actor photo: ${actor.name}`);
                this.src = './images/main.png';
                this.alt = 'Фото відсутнє';
            };
            
            // Create name element
            const nameElement = document.createElement('h4');
            nameElement.className = 'actor-name';
            nameElement.textContent = actor.name;
            
            // Add click handler to name as well
            nameElement.addEventListener('click', async function() {
                // Try both possible bio file names
                const bioPath = await checkBioFileExists(`./images/actors/${actor.folder}/Bio.txt`, `./images/actors/${actor.folder}/bio.txt`);
                showBioModal(primarySrc, actor.name, 'Актор', bioPath);
            });
            
            // Build card
            actorCard.appendChild(img);
            actorCard.appendChild(nameElement);
            
            actorsContainer.appendChild(actorCard);
        });
        
        console.log(`Loaded ${actors.length} actor photos`);
    }
    
    // Load ex-actors photos
    const exActorsContainer = document.getElementById('ex-actors-container');
    if (exActorsContainer) {
        // Define ex-actor data with specific image filenames
        const exActors = [
            { name: "Олександр Квочкін", folder: "3. Олександр Квочкін", image: "graj_praha-350.jpg" },
            { name: "Іріна Лі", folder: "Іріна Лі", image: "IrinaLi.jpg" },
            { name: "Наталія Шевчук", folder: "Наталія Шевчук", image: "shevchuk.jpg" },
            { name: "Ольга Владицька", folder: "Ольга Владицька", image: "Vlad.jpg" }
        ];
        
        // Clear container
        exActorsContainer.innerHTML = '';
        
        // Add each ex-actor
        exActors.forEach(exActor => {
            const exActorCard = document.createElement('div');
            exActorCard.className = 'actor-card';
            
            // Create image element if image exists
            const img = document.createElement('img');
            let primarySrc;
            
            if (exActor.image) {
                primarySrc = `./images/ex-actors/${exActor.folder}/${exActor.image}`;
                img.src = primarySrc;
                img.alt = exActor.name;
                img.className = 'actor-photo';
            } else {
                // Use placeholder if no image exists
                primarySrc = './images/main.png';
                img.src = primarySrc;
                img.alt = 'Фото відсутнє';
                img.className = 'actor-photo';
            }
            
            // Ensure the image path for the bio modal is correct
            const bioImagePath = exActor.image ? `./images/ex-actors/${exActor.folder}/${exActor.image}` : './images/main.png';
            
            // Add click handler to show bio
            img.addEventListener('click', async function() {
                // Try both possible bio file names
                const bioPath = await checkBioFileExists(`./images/ex-actors/${exActor.folder}/Bio.txt`, `./images/ex-actors/${exActor.folder}/bio.txt`);
                showBioModal(
                    bioImagePath, 
                    exActor.name, 
                    'Екс-актор', 
                    bioPath
                );
            });
            
            // Add error handling
            img.onerror = function() {
                console.warn(`Failed to load ex-actor photo: ${exActor.name}`);
                this.src = './images/main.png';
                this.alt = 'Фото відсутнє';
            };
            
            // Create name element
            const nameElement = document.createElement('h4');
            nameElement.className = 'actor-name';
            nameElement.textContent = exActor.name;
            
            // Add click handler to name as well
            nameElement.addEventListener('click', async function() {
                // Try both possible bio file names
                const bioPath = await checkBioFileExists(`./images/ex-actors/${exActor.folder}/Bio.txt`, `./images/ex-actors/${exActor.folder}/bio.txt`);
                showBioModal(
                    bioImagePath, 
                    exActor.name, 
                    'Екс-актор', 
                    bioPath
                );
            });
            
            // Build card
            exActorCard.appendChild(img);
            exActorCard.appendChild(nameElement);
            
            exActorsContainer.appendChild(exActorCard);
        });
        
        console.log(`Loaded ${exActors.length} ex-actor photos`);
    }
}

// Flag to prevent multiple loading calls
let actorPhotosLoaded = false;

// Initialize actor photos when actors page is shown
function initActorPage() {
    const actorsPage = document.getElementById('actors');
    if (actorsPage) {
        // Use MutationObserver to detect when actors page becomes active
        const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    if (actorsPage.classList.contains('active') && !actorPhotosLoaded) {
                        actorPhotosLoaded = true;
                        // Small delay to ensure page is fully rendered
                        setTimeout(() => {
                            loadActorPhotos();
                            // Reset flag after a delay to allow reloading if needed
                            setTimeout(() => {
                                actorPhotosLoaded = false;
                            }, 1000);
                        }, 100);
                    }
                }
            });
        });
        
        observer.observe(actorsPage, { attributes: true });
        
        // Also try to load immediately if page is already active
        if (actorsPage.classList.contains('active') && !actorPhotosLoaded) {
            actorPhotosLoaded = true;
            loadActorPhotos();
            // Reset flag after a delay
            setTimeout(() => {
                actorPhotosLoaded = false;
            }, 1000);
        }
    }
}

// Call initActorPage when DOM is loaded
document.addEventListener('DOMContentLoaded', initActorPage);

// Helper function to check if bio file exists
async function checkBioFileExists(path1, path2) {
    try {
        const response1 = await fetch(path1, { method: 'HEAD' });
        if (response1.ok) {
            return path1;
        }
    } catch (e) {}
    
    try {
        const response2 = await fetch(path2, { method: 'HEAD' });
        if (response2.ok) {
            return path2;
        }
    } catch (e) {}
    
    // If neither exists, return the conventional lowercase name
    return path2;
}

// Function to show bio modal
async function showBioModal(imageSrc, name, role, bioPath) {
    try {
        // Get modal elements
        const modal = document.getElementById('bio-modal');
        const bioImage = document.getElementById('bio-image');
        const bioName = document.getElementById('bio-name');
        const bioText = document.getElementById('bio-text');
        
        if (!modal || !bioImage || !bioName || !bioText) {
            console.error('Bio modal elements not found');
            return;
        }
        
        // Set image and name
        bioImage.src = imageSrc;
        bioImage.alt = name;
        bioName.textContent = name;
        
        // Show loading text while fetching bio
        bioText.textContent = 'Завантаження...';
        
        // Fetch bio text from file
        const response = await fetch(bioPath);
        if (!response.ok) {
            throw new Error(`Could not fetch bio: ${response.status}`);
        }
        
        const bioContent = await response.text();
        
        // Process and display bio text
        // Sanitize the content to prevent HTML injection
        const sanitizedContent = bioContent.replace(/[<>&]/g, function(char) {
            switch(char) {
                case '<': return '&lt;';
                case '>': return '&gt;';
                case '&': return '&amp;';
            }
        });
        
        bioText.innerHTML = sanitizedContent
            .split('\n')
            .filter(line => line.trim() !== '')
            .map(line => `<p>${line.trim()}</p>`)
            .join('');
        
        // Show modal
        modal.style.display = 'block';
        document.body.style.overflow = 'hidden';
        
        // Add close handlers
        addBioModalCloseHandlers();
        
    } catch (error) {
        console.error('Error showing bio modal:', error);
        
        // Show error message in modal
        const bioText = document.getElementById('bio-text');
        if (bioText) {
            bioText.innerHTML = '<p>Помилка при завантаженні біографії</p>';
        }
    }
}

// Add close handlers for bio modal
function addBioModalCloseHandlers() {
    const modal = document.getElementById('bio-modal');
    const closeBtn = document.querySelector('.bio-close');
    
    if (closeBtn) {
        closeBtn.onclick = function() {
            closeBioModal();
        };
    }
    
    // Close when clicking outside content
    if (modal) {
        modal.onclick = function(event) {
            if (event.target === modal) {
                closeBioModal();
            }
        };
    }
    
    // Keyboard navigation
    document.addEventListener('keydown', function(event) {
        if (modal && modal.style.display === 'block') {
            if (event.key === 'Escape') {
                closeBioModal();
            }
        }
    });
}

// Close bio modal
function closeBioModal() {
    const modal = document.getElementById('bio-modal');
    if (modal) {
        modal.style.display = 'none';
        document.body.style.overflow = '';
    }
}

// Export for debugging
window.GrajTheater = {
    showPage,
    updateActiveNav,
    closeMobileMenu,
    showPlayPhotos,
    openLightbox,
    closeLightbox,
    showBioModal,
    closeBioModal
};